// extracted by mini-css-extract-plugin
export default {"copy-container":"CopyToClipboard_copy-container__jl8w6","copy-text":"CopyToClipboard_copy-text__8jnl9","copy-button":"CopyToClipboard_copy-button__jK1iI"};